const FLAG_MAINTENANCE_MODAL = 'maintenance-modal';

const USER_CONTEXT_ON_LAUNCHDARKLY = {
  key: '',
  kind: 'device',
  anonymous: true,
};

export { FLAG_MAINTENANCE_MODAL, USER_CONTEXT_ON_LAUNCHDARKLY };
